import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const AdminPanelSettingsSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default AdminPanelSettingsSVG;
